import { OrganizationKeyName } from "../../../model/Organization";

export const GET_NEWS_LIST = "SHOP:GET_NEWS_LIST";

export const getNewsListAction = (organization: OrganizationKeyName) => ({
  type: GET_NEWS_LIST as typeof GET_NEWS_LIST,
  organization,
});

export type GetNewsListAction = ReturnType<typeof getNewsListAction>;
